export const SEND_OTP_URL = "/super-admin/auth/login/otp";
export const VERIFY_OTP_URL = "/super-admin/auth/login/verify-otp";
export const REFRESH_TOKEN_URL = "/auth/refresh-token";
//profile
export const GET_PROFILE_URL = "/super-admin/auth/profile";

//dashboard
export const GET_DASHBOARD_URL = "/super-admin/dashboard";
export const GET_DASHBOARD_ACTIVITIES_URL = "/super-admin/dashboard/activities";

//company
export const GET_COMPANY_LIST_URL = "/super-admin/company/list";
export const ADD_COMPANY_URL = "/super-admin/company/add";
export const GET_COMPANY_DETAILS_URL = "/super-admin/company?companyId=";
export const UPDATE_COMPANY_DETAILS_URL = "/super-admin/company/update?companyId=";
export const DELETE_COMPANY_URL = "/super-admin/company/delete?companyId=";
export const SUSPEND_COMPANY_URL = "/super-admin/company/suspend?companyId=";

//announcements
export const GET_ANNOUNCEMENTS_URL = "/super-admin/announcement/all";
export const ADD_ANNOUNCEMENT_URL = "/super-admin/announcement/create";
export const UPDATE_ANNOUNCEMENT_URL = "/super-admin/announcement/update";
export const DELETE_ANNOUNCEMENT_URL = "/super-admin/announcement/delete";

//contact requests
export const GET_CONTACT_REQUESTS_URL = "/super-admin/contact-us/list";
export const DELETE_CONTACT_REQUEST_URL = "/super-admin/contact-us/delete?id=";
export const GET_CONTACT_DETAILS_URL = "/super-admin/contact-us/single?id=";
export const UPDATE_CONTACT_STATUS_URL = "/super-admin/contact-us/status?id=";

export const GET_TRUSTED_BY_LIST_URL = "/super-admin/trusted-by/list";
export const ADD_TRUSTED_BY_URL = "/super-admin/trusted-by/add";
export const UPDATE_TRUSTED_BY_URL = "/super-admin/trusted-by/update?id=";
export const DELETE_TRUSTED_BY_URL = "/super-admin/trusted-by/delete?id=";

// reviews
export const GET_REVIEW_LIST_URL = "/super-admin/review/list";
export const ADD_REVIEW_URL = "/super-admin/review/add";
export const GET_REVIEW_DETAILS_URL = "/super-admin/review/single?id=";
export const UPDATE_REVIEW_URL = "/super-admin/review/update?id=";
export const DELETE_REVIEW_URL = "/super-admin/review/delete?id=";
export const TOGGLE_REVIEW_STATUS_URL = "/super-admin/review/toggle-status?id=";

// maintenance
export const GET_MAINTENANCE_URL = "/super-admin/maintenance";
export const TOGGLE_MAINTENANCE_URL = "/super-admin/maintenance/toggle";

// blogs
export const GET_BLOG_LIST_URL = "/super-admin/blog/list";
export const ADD_BLOG_URL = "/super-admin/blog/add";
export const GET_BLOG_DETAILS_URL = "/super-admin/blog/single?id=";
export const UPDATE_BLOG_URL = "/super-admin/blog/update?id=";
export const DELETE_BLOG_URL = "/super-admin/blog/delete?id=";
export const TOGGLE_BLOG_STATUS_URL = "/super-admin/blog/toggle-status?id=";